window.addEventListener("load", function(){
    window.cookieconsent.initialise({
        "palette": {
            "popup": {
                "background": "#343a40"
            },
            "button": {
                "background": "#e51e2c",
                "text": "#ffffff"
            }
        },
        "position": "bottom-left",
        "content": {
            "message": "Diese Website benutzt Cookies und Google Analytics. Wenn du die Website weiter nutzt, gehen wir von deinem Einverständnis aus.",
            "dismiss": "OK",
            "link": "Info &amp; Opt-Out",
            "href": "https://www.xn--vfr-wrzberg-xhb.de/datenschutzerklaerung"
        }
    })
});

(function($) {
    $(document).ready(function() {
        $('img').unveil(300, function () {
            $(this).load(function() {
                $(this).removeClass('loader');
            });
        });
    });
    $(window).resize(function() {
        $('img').unveil(300, function () {
            $(this).load(function() {
                $(this).removeClass('loader');
            });
        });
    });
}(jQuery));
